module.exports = __webpack_public_path__ + "img/mapa.229ffb98.svg";